import React from 'react'
import PropTypes from 'prop-types'
import { Input, InputGroup } from 'reactstrap'
import styles from './Search.scss'

class Search extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      search: ''
    }
  }

  changeSearch = e => {
    this.props.onSearchChange(e.target.value)
  }

  render () {
    return (
      <div className={styles.container}>
        <InputGroup>
          <Input placeholder='Search for files' onChange={this.changeSearch} value={this.props.value} />
        </InputGroup>
      </div>
    )
  }
}
Search.propTypes = {
  value: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search/Search.js